import { useQuery } from '@apollo/client';
import { ReactNode } from 'react';
import { CURRENT_USER } from 'services/auth';
import { CommunityUser, ConnectedAccount, User, GeoIpLocation } from 'services/graphqltypes';
import * as Sentry from "@sentry/react";
import { UserContext, UserPermissions } from './UserContext';

function UserContextProvider({ children }: { children: ReactNode }) {

  const { data, refetch: refetchCurrentUser, loading } = useQuery(CURRENT_USER);

  const currentUser = data?.currentUser as User;
  const currentUserGeoIPLocation = data?.currentUserGeoIPLocation?.latitude && data?.currentUserGeoIPLocation as GeoIpLocation; // leave undefined if we don't get it (not using the error field)

  Sentry.setUser({ id: currentUser?.id, username: currentUser?.username });

  const isAuthenticated = !!currentUser?.id;

  const currentUserPermissions = currentUser?.communityUsers?.nodes.map((communityUser: CommunityUser): UserPermissions => {
    const communityRolePermissions = communityUser.communityRolePermissions;
    let permissions = [] as any;
    if (communityRolePermissions) {
      permissions = Object.keys(communityRolePermissions).filter((key) => {
        return communityRolePermissions[key] === true;
      });
    }
    return {
      communityId: communityUser.communityId,
      communityName: communityUser.community.name,
      communitySlug: communityUser.community.slug,
      role: communityUser.communityRole.name,
      permissions,
    };
  });

  const currentUserChildren = currentUser?.childConnectedAccounts?.nodes.map((connectedAccount: ConnectedAccount) => {
    return connectedAccount.connectedUser;
  });

  const userContextValues = {
    loading,
    isAuthenticated,
    currentUser,
    currentUserGeoIPLocation,
    refetchCurrentUser,
    currentUserPermissions,
    currentUserChildren,
  };

  return (
    <UserContext.Provider value={{ ...userContextValues }}>
      {children}
    </UserContext.Provider>
  );
}

export default UserContextProvider;
